import { FormGroup } from '@angular/forms';
import { Store } from '@ngrx/store';
import { FormListeners } from '../../../models/beans/form-listeners.abstract';
import { Revisione53State } from '../../../store/revisione53.reducers';
import { setNatMutCkMutualisticiListeners } from './natura-mutualistica-ck-mutualistici.listeners';
import { setNatMutInseritoVersoSociListeners } from './natura-mutualistica-inserito-verso-soci.listeners';
import { setNatMutSchedaValoriListeners } from './natura-mutualistica-scheda-valori.listeners';
import { setNatMutSchedaCalcoliListeners } from './natura-mutualistica-scheda-calcoli.listeners';
import { setNatMutCkValoreQuantitaListeners } from './natura-mutualistica-ck-valore-quantita.listeners';
import { setNatMutEnableDisableListeners } from './natura-mutualistica-enable-disable.listeners';

export class NaturaMutualisticaFormListeners extends FormListeners {
    private readonly store: Store<Revisione53State>;

    constructor(form: FormGroup, store: Store<Revisione53State>) {
        super(form);
        this.store = store;
    }

    setListeners(): void {
        setNatMutCkMutualisticiListeners(this.form, this.store);
        setNatMutInseritoVersoSociListeners(this.form, this.store);
        setNatMutSchedaValoriListeners(this.form, this.store);
        setNatMutSchedaCalcoliListeners(this.form, this.store);
        setNatMutCkValoreQuantitaListeners(this.form, this.store);
        setNatMutEnableDisableListeners(this.form, this.store);
    }
}
